export default {
  title: 'Control de acceso: {{role}}',
  form: {
    companies: {
      label: 'Visible para todos los miembros con el rol {{role}}',
      tooltip: 'Esto se añadirá a los lugares donde el miembro del equipo se registró',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos, por favor recarga la página',
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
